module.exports = __webpack_public_path__ + "img/frasagal01.12ab3e98.png";